import React from "react";
import "../../node_modules/react-modal-video/css/modal-video.css";

import misyon from "../assets/images/misyon.jpeg";
import vizyon from "../assets/images/vizyon.jpeg";
import ilke_prensip from "../assets/images/ilke_prensip.jpeg";
import otizm_meclis from "../assets/images/otizm_meclis.jpg";
import gazi_logo from "../assets/images/gazi_logo.jpeg";
import headerImg1 from "../assets/images/hcrh6317-711x948.jpg";

export default function About() {
  return (
    <>
      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="grid grid-cols-1 lg:grid-cols-12 md:grid-cols-2 gap-10 items-center">
            <div className="lg:col-span-5">
              <div className="relative">
                <img
                  src={headerImg1}
                  className="rounded-lg shadow-lg relative"
                  alt=""
                />
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="lg:ms-7">
                <h3 className="mb-4 md:text-2xl text-xl font-medium">
                  Hakkımızda: Beş Nokta Otizm Yaşam Derneği
                </h3>

                <p
                  className="dark:text-white max-w-2xl mx-auto"
                  style={{ lineHeight: 2, textAlign: "justify" }}
                >
                  <strong>Beş Nokta Otizm Yaşam Derneği</strong>, otizmle ilgili
                  gönüllülük ve farkındalık esasına dayanan, hak mücadelesi
                  temelli bir sivil toplum örgütüdür. Dernek, otizmli bireylere
                  ve ailelerine eğitim, destek ve bilgi vermeyi hedefleyen uzman
                  eğitimciler ve meslek elemanlarından oluşmaktadır.
                  <br />
                  <br />
                  Başta İstanbul olmak üzere, Türkiye genelinde otizmli bireyler
                  ve aileleri için akademik, sosyal, gelişimsel destek
                  sağlanması ve bilgi entegrasyonu konularında çalışmalar
                  yürütmektedir. Ayrıca otizmle (diğer tüm zihinsel engel
                  grupları ve Down sendromu dahil) ilgili ulusal politikaların
                  belirlenmesinde aktif rol oynamaktadır.
                  <br />
                  <br />
                  Bu nedenle, otizmli bireyler, aileleri ve tüm toplum için
                  diyoruz ki: “Uzun yollar, ilk adımla başlar. Bu yolda hep
                  birlikte yürüyelim!”
                </p>

                <div className="relative mt-8">
                  Beş Nokta Otizm Yaşam Derneği (BENOYDER) <br />
                  Kuruluş tarihi: 17 KASIM 2015
                </div>
                <div className="relative mt-8">
                  <img
                    src={otizm_meclis}
                    style={{
                      width: "100px !important",
                      float: "left",
                      marginRight: "10px",
                    }}
                    className="h-auto rounded-lg shadow-md"
                  />
                  <img
                    src={gazi_logo}
                    width={175}
                    style={{ width: "30px !important", float: "left" }}
                    className="h-auto rounded-lg shadow-md"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="grid grid-cols-1 lg:grid-cols-12 md:grid-cols-2 gap-10 items-center">
            <div className="lg:col-span-6">
              <div className="relative">
                <img
                  src={misyon}
                  className="rounded-lg shadow-lg relative"
                  alt=""
                  width={700}
                />
              </div>
            </div>

            <div className="lg:col-span-6">
              <div className="relative">
                <img
                  src={vizyon}
                  className="rounded-lg shadow-lg relative"
                  alt=""
                  width={700}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="lg:col-span-5">
        <div className="relative">
          <div className="relative flex justify-center">
            <img
              src={ilke_prensip}
              className="rounded-lg shadow-lg"
              alt=""
              width={700}
            />
          </div>
        </div>
      </div>
    </>
  );
}
